import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import * as React from "react";

export const BackInStockToast = () => (
  <StrictLocalMsg
    id="nnwDjA"
    defaultMessage="We’ll notify you via email when the product is back in stock."
    description={{
      text: "Show this when a back-in-stock button is clicked",
      img: "https://cdn.faire.com/fastly/907513e0e1fa73fb2f04329a63382c8114da7381ab5a69bc032bec1d21f36d32.png",
    }}
  />
);
